const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.new-product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          productRecommendationsSection.style.height = "auto"
          productRecommendationsSection.style.visibility = "visible"

          initRecommendationsSlider();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.new-product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  function initRecommendationsSlider() {
    const swiperContainer = document.querySelector('.recommended-products-slider');
    if (!swiperContainer || typeof Swiper === 'undefined') return;

    new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      centeredSlides: false,
      centeredSlidesBounds: false,
      slidesPerGroup: 1,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: '.recommendations-slider-next',
        prevEl: '.recommendations-slider-prev',
      },
       breakpoints: {
        768: {
          slidesPerGroup: 4,
        },

      },
    });
  }
